/* eslint-disable react/no-array-index-key */
// @ts-nocheck
import { Grid, makeStyles } from '@material-ui/core';
import React, { useState, useRef, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';
import Stepper from './Stepper';
const useStyles = makeStyles((theme) => ({
    root: {
        scrollbarWidth: 'none',
        overflowX: 'scroll',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    itemWrapper: {},
    item: {
        width: ({ itemWidth }) => itemWidth,
        padding: theme.spacing(2),
    },
}));
const Carousel = ({ children, onStepChange }) => {
    const [itemWidth, setItemWidth] = useState(0);
    const classes = useStyles({ itemWidth });
    const ref = useRef();
    const { ref: refCall } = useSwipeable({
        onSwipedLeft: scrollLeft,
        onSwipedRight: scrollRight,
        trackMouse: true,
        trackTouch: true,
    });
    const [step, setStep] = useState(0);
    const updateItemWidth = () => {
        const { clientWidth } = ref === null || ref === void 0 ? void 0 : ref.current;
        setItemWidth(clientWidth);
    };
    useEffect(() => {
        updateItemWidth();
        window.addEventListener('resize', updateItemWidth);
        return () => {
            window.removeEventListener('resize', updateItemWidth);
        };
    }, [ref]);
    const elements = React.Children.toArray(children);
    function scrollLeft() {
        const newStep = Math.min(step + 1, elements.length - 1);
        ref.current.scrollTo({
            left: newStep * itemWidth,
            top: 0,
            behavior: 'smooth',
        });
        setStep(newStep);
        onStepChange(newStep);
    }
    function scrollRight() {
        const newStep = Math.max(step - 1, 0);
        ref.current.scrollTo({
            left: newStep * itemWidth,
            top: 0,
            behavior: 'smooth',
        });
        setStep(newStep);
        onStepChange(newStep);
    }
    const onStep = (newStep) => {
        ref.current.scrollTo({
            left: newStep * itemWidth,
            top: 0,
            behavior: 'smooth',
        });
        setStep(newStep);
        onStepChange(newStep);
    };
    return (React.createElement(Grid, { spacing: 8, className: classes.root, container: true, direction: 'column' },
        React.createElement(Grid, { ref: (el) => {
                refCall(el);
                ref.current = el;
            }, className: classes.root, container: true, direction: 'row', wrap: 'nowrap', alignItems: 'flex-end' }, elements.map((item, index) => (React.createElement(Grid, { key: `${index}-item`, item: true, className: classes.itemWrapper },
            React.createElement(Grid, { key: `${index}-container`, container: true, justifyContent: 'center', className: classes.item }, item))))),
        elements.length >= 2 && (React.createElement(Stepper, { steps: elements.length, activeStep: step, onStep: onStep }))));
};
export default Carousel;
